import { supabase } from "@/services/supabase/createClient";

export const renameWorkspace = async (workspaceId: string, name: string) => {
  const { error } = await supabase.from("resources").update({ name }).eq("resource_id", workspaceId);
  if (error) {
    throw new Error(error.message);
  }
};
